<!-- Copyright (c) 2018-2022 VMware, Inc. All rights reserved. VMware Confidential -->
<clr-modal [clrModalOpen]="opened"
           (clrModalOpenChange)="closeDialog(false)"
           [clrModalClosable]="true"
           dr-focus>
    <h3 class="modal-title">{{title | vtranslate : titleParams[0] :titleParams[1] :titleParams[2]}}</h3>
    <div class="modal-body">
        <div class="dialog-content">
            <cds-icon [attr.shape]="iconShape"
                      [attr.aria-hidden]="true"
                      size="32"
                      *ngIf="iconShape"></cds-icon>
            <p *ngIf="!innerHTML">{{message | vtranslate :messageParams[0] :messageParams[1] :messageParams[2]}}</p>
            <p *ngIf="innerHTML" [innerHTML]="message | vtranslate :messageParams[0] :messageParams[1] :messageParams[2]"></p>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button"
                class="btn btn-primary"
                [ngClass]="confirmationBtnStyle"
                (click)="closeDialog(true)">
            {{confirmationBtnText | vtranslate}}
        </button>
    </div>
</clr-modal>
